export default __webpack_public_path__ + "static/media/burger-demo.615c0c5c.gif";